"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
(0, tslib_1.__exportStar)(require("./getAppletsOpenId.request"), exports);
(0, tslib_1.__exportStar)(require("./wechatAppletsLogin.request"), exports);
(0, tslib_1.__exportStar)(require("./wechatAppletsLoginOut.request"), exports);
(0, tslib_1.__exportStar)(require("./wechatAppletsLoginWithMobile.request"), exports);
(0, tslib_1.__exportStar)(require("./getPhoneDynamicCodeForApplets.request"), exports);
//# sourceMappingURL=index.js.map